"use client"

export default function UsuarioList({ usuarios = [], isAdmin = false, onToggleAtivo }) {
  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Email</th>
            <th>Papel</th>
            {isAdmin && <th>Instituição</th>}
            <th>Último Acesso</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map((user) => (
            <tr key={user.id}>
              <td>{user.nome}</td>
              <td>{user.email}</td>
              <td>
                <span className={`badge badge-${user.papel}`}>{user.papel.replace("_", " ")}</span>
              </td>
              {isAdmin && <td>{user.instituicao?.nome || "-"}</td>}
              <td>{user.ultimo_acesso ? new Date(user.ultimo_acesso).toLocaleDateString() : "-"}</td>
              <td>
                <span className={`status ${user.ativo ? "ativo" : "inativo"}`}>{user.ativo ? "Ativo" : "Inativo"}</span>
              </td>
              <td>
                <button
                  className={`btn-toggle ${user.ativo ? "btn-disable" : "btn-enable"}`}
                  onClick={() => onToggleAtivo(user.id, user.ativo)}
                >
                  {user.ativo ? "Desativar" : "Ativar"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
